module.exports = __webpack_public_path__ + "static/img/FR.9db890a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/FR.png
// module id = knX5
// module chunks = 2